import script from "./CreateUsersView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateUsersView.vue?vue&type=script&setup=true&lang=ts"

import "./CreateUsersView.vue?vue&type=style&index=0&id=52ef3f66&lang=scss"

const __exports__ = script;

export default __exports__